import React from 'react'
import '../styles/navbar.css'
import { useTranslation } from 'react-i18next';
function Navbar_2() {
  const { t } = useTranslation("home");

  return (
    <div className='navbar_2 '>
        <a href="/" className='active'> {t('home')} </a>
        <a href="/categories"> {t('categories')} </a>
        <a href="/about_us"> {t('about_us')} </a>
        <a href="/contact_us"> {t('contact_us')} </a>
    </div>
  )
}

export default Navbar_2